import { MenuStatusSchema, type MenuStatus as GeneratedMenuStatus } from '~/services/api/generated'

export type MenuStatus = GeneratedMenuStatus

export const MenuStatus = {
  ACTIVE: MenuStatusSchema.enum.active,
  DRAFT: MenuStatusSchema.enum.draft,
  PUBLISHED: MenuStatusSchema.enum.published,
  UNPUBLISHED: MenuStatusSchema.enum.unpublished
} satisfies Record<string, GeneratedMenuStatus>

export const MenuStatusValues: readonly GeneratedMenuStatus[] = [
  MenuStatusSchema.enum.active,
  MenuStatusSchema.enum.draft,
  MenuStatusSchema.enum.published,
  MenuStatusSchema.enum.unpublished
]
